import React, {useState} from 'react';

import {Modal} from 'reactstrap';
import EditClassView from "../Resources/Yclass/EditClassView";

const AddOneClassModal = (props) => {
    const [visible, setVisible] = useState(true);

    function toggle(formModal) {
        setVisible(!visible);
        props.toggleModal();
    }

    return (
        <Modal
            className="modal-dialog-centered modal-fluid"
            contentClassName="bg-transparent"
            isOpen={visible}
            toggle={() => toggle("notificationModal")}
        >
            <EditClassView
                date={props.date}
                yclass={props.yclass}
                goToProfile={props.goToProfile}
                closeEditClassView={props.closeEditClassView}
                teachers={props.teachers}
                rooms={props.rooms}
                showEditClassType={false}
                createClassNewClassType={props.createClassNewClassType}
            />
        </Modal>
    );
};

export default AddOneClassModal;